// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"n0-z"};